export const asIOneSheet = {
  data: `<svg width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.9996 0H1.99981C1.26649 0 0.666504 0.6 0.666504 1.33333V10.6667C0.666504 11.4 1.26649 12 1.99981 12H11.9996C12.7329 12 13.3329 11.4 13.3329 10.6667V1.33333C13.3329 0.6 12.7329 0 11.9996 0ZM11.9996 1.33333V3.33333H1.99981V1.33333H11.9996ZM8.66634 10.6667H5.33308V4.66667H8.66634V10.6667ZM1.99981 4.66667H3.99977V10.6667H1.99981V4.66667ZM9.99965 10.6667V4.66667H11.9996V10.6667H9.99965Z"/>
  </svg>
  `,
  name: 'ionesheet',
};
